<template>
  <header class="marketplace-table-header p-md bg-gray-100">
    <div class="marketplace-table-header--titles">
      <slot name="titles" />
    </div>
    <div v-if="$slots.buttons" class="marketplace-table-header--buttons">
      <slot name="buttons" />
    </div>
    <slot />
  </header>
</template>

<script>
import t from '../../main/i18n';

export default {
  name: 'MarketplaceTableHeader',
  filters: {
    t
  }
};
</script>

<style lang="scss">
@import '../../../scss/variables';
@import '../../../scss/system';

.marketplace-table-header {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1.6rem;
  border-bottom: 1px solid $color-gray-400;
  border-radius: 1.2rem 1.2rem 0 0;

  @media (min-width: $screen-md) {
    flex-direction: row;
  }

  &--titles {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;

    @media (min-width: $screen-md) {
      flex-direction: row;
      gap: 3.2rem;
    }

    > div {
      column-gap: 0.8rem;
    }
  }

  &--buttons {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;

    @media print {
      display: none;
    }

    @media (min-width: $screen-md) {
      flex-direction: row;
      justify-content: end;
      flex-wrap: wrap;
    }

    > a .slo-button {
      width: 100%;
    }
  }
}
</style>
